import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconCampfireBlack({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="none">
				<g fill="#000">
					<path d="M13.131 3.391a.337.337 0 0 1 .596.312l-.014.027-9.428 16.163a.337.337 0 0 1-.596-.313l.014-.027z" />
					<path d="M10.055 18.713c.186 0 .337.19.337.425 0 .222-.136.405-.308.423l-.029.002H4.668c-.186 0-.337-.19-.337-.425 0-.223.135-.405.308-.424l.029-.001zm9.428 0c.186 0 .336.19.336.425 0 .222-.135.405-.307.423l-.03.002h-5.386c-.186 0-.337-.19-.337-.425 0-.223.135-.405.308-.424l.029-.001zm-6.004 1.16a.337.337 0 0 1 .44-.11l.026.016 1.01.674a.337.337 0 0 1-.347.576l-.026-.016-1.01-.673a.337.337 0 0 1-.093-.467" />
				</g>
				<path
					fill="#000"
					d="M9.096 17.187a.337.337 0 0 1 .438-.122l.026.015 1.01.632a.337.337 0 0 1-.33.586l-.026-.015-1.01-.632a.337.337 0 0 1-.108-.464m1.109 2.593a.337.337 0 0 1 .398.542l-.024.018-1.01.673a.337.337 0 0 1-.399-.542l.025-.018zm4.377-2.694a.337.337 0 0 1 .398.542l-.024.018-1.01.674a.337.337 0 0 1-.399-.543l.025-.018zM13.13 3.393a1.683 1.683 0 1 1 .617 2.3.337.337 0 0 1 .337-.584 1.01 1.01 0 1 0-.37-1.38.337.337 0 1 1-.583-.336Zm-2.571-.123a.337.337 0 0 1 .444.095l.016.026 9.428 16.162a.337.337 0 0 1-.565.365l-.017-.025L10.438 3.73a.337.337 0 0 1 .12-.46Z"
				/>
				<path
					fill="#000"
					d="M8.72 2.776a1.684 1.684 0 0 1 2.3.616.337.337 0 0 1-.583.337 1.01 1.01 0 1 0-.37 1.38.337.337 0 0 1 .337.583A1.684 1.684 0 0 1 8.72 2.776m7.582.147a.337.337 0 0 1 .328.587l-.027.015-.673.337a.337.337 0 0 1-.328-.587l.027-.015z"
				/>
				<path
					fill="#000"
					d="M7.304 3.073a.337.337 0 0 1 .424-.163l.028.012.673.337a.337.337 0 0 1-.273.615l-.028-.013-.673-.336a.337.337 0 0 1-.15-.452Z"
				/>
				<path
					fill="#E42822"
					d="M12.225 14.727a.337.337 0 0 1 .374.56c-1.258.841-1.87 1.861-1.87 3.758a.337.337 0 0 1-.674 0c0-2.136.734-3.358 2.17-4.318m1.047 2.001a.337.337 0 0 1 .451.15l.012.025.025.055.013.032.027.072q.02.057.043.127l.03.097.014.053.03.114c.112.447.178.98.178 1.597a.337.337 0 0 1-.673 0c0-.562-.06-1.04-.158-1.434a3 3 0 0 0-.105-.342l-.03-.077-.008-.017a.337.337 0 0 1 .15-.452Z"
				/>
				<path
					fill="#E42822"
					d="M13.121 16.879a.337.337 0 1 1 .602.3 1.54 1.54 0 0 1-1.05.827q-.144.03-.233.032h-.028a.337.337 0 0 1-.029-.672l.037-.001.031-.003a.88.88 0 0 0 .67-.483"
				/>
				<path
					fill="#E42822"
					d="M12.519 14.688c.176.059.271.25.213.426l-.043.14a7 7 0 0 0-.099.378 5.5 5.5 0 0 0-.133.852c-.03.458.031.794.173.958l.02.022a.337.337 0 1 1-.476.476c-.33-.329-.433-.846-.389-1.5a6 6 0 0 1 .15-.96q.041-.177.085-.336l.04-.139.033-.104a.337.337 0 0 1 .426-.213m1.24 4.025c.186 0 .336.15.336.337a2.02 2.02 0 1 1-4.04 0 .337.337 0 0 1 .674 0 1.347 1.347 0 1 0 2.693 0c0-.186.15-.337.337-.337"
				/>
			</g>
		</svg>
	);
}
